import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TableLazyLoadEvent } from 'primeng/table';
import { Subject, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs/operators';

import { VesselService } from '../vessel.service';
import { VesselDto } from '../vessel.model';

import {
  TableColumn,
  TableAction,
} from 'src/app/shared/models/table-config.model';

@Component({
  selector: 'app-vessel-list-modal',
  templateUrl: './vessel-list-modal.component.html',
  standalone: false,
})
export class VesselListModalComponent implements OnInit, OnDestroy {
  vessels: VesselDto[] = [];
  totalItems: number = 0;
  loading: boolean = true;
  filter: string = '';

  // Cache do último evento da tabela
  lastTableEvent: TableLazyLoadEvent = { first: 0, rows: 10 };

  private search$ = new Subject<string>();
  private trigger$ = new Subject<void>();
  private destroy$ = new Subject<void>();

  // Configuração das colunas (Visual novo)
  tableColumns: TableColumn[] = [
    { field: 'id', header: 'ID', type: 'text', width: '15%', sortable: true },
    { field: 'imo', header: 'IMO', type: 'text', width: '25%', sortable: true },
    {
      field: 'name',
      header: 'VESSEL',
      type: 'text',
      width: '45%',
      sortable: true,
    },
    { field: 'actions', header: '', type: 'actions', width: '15%' },
  ];

  tableActions: TableAction[] = [
    {
      label: 'Select',
      command: (row) => this.onSelectItem(row),
    },
  ];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private vesselService: VesselService,
  ) {}

  ngOnInit(): void {
    this.search$
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(() => {
        this.lastTableEvent.first = 0;
        this.trigger$.next();
      });

    this.trigger$
      .pipe(
        tap(() => (this.loading = true)),
        switchMap(() =>
          this.fetchVessels().pipe(
            catchError(() => {
              this.loading = false;
              return of(null);
            }),
          ),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe((data: any) => {
        if (!data) return;
        this.vessels = data.vessels || [];
        this.totalItems = data.vesselsCount || 0;
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSearchChange() {
    if (this.filter.length > 0 && this.filter.length < 3) return;
    this.search$.next(this.filter);
  }

  loadVesselsLazy(event: TableLazyLoadEvent) {
    this.lastTableEvent = event;
    this.trigger$.next();
  }

  private fetchVessels() {
    const sortField = Array.isArray(this.lastTableEvent.sortField)
      ? this.lastTableEvent.sortField[0]
      : this.lastTableEvent.sortField;

    return this.vesselService.getVessels(
      this.lastTableEvent.rows || 10,
      this.lastTableEvent.first || 0,
      this.filter,
      sortField,
      this.lastTableEvent.sortOrder,
    );
  }

  onSelectItem(vessel: VesselDto) {
    // Mantendo o padrão de retorno { vessel } para compatibilidade
    this.ref.close({ vessel });
  }

  closeModal() {
    this.ref.close();
  }
}
